export * from './article-news-document'
